import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import dialogCommon from 'Theme/DialogCommon.jss';
import Theme from 'Theme';

let baseStyles = {
    ...dialogCommon,
    buttonContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column-reverse'
    },
    buttonWidth: {
        maxWidth: 500,
        minWidth: 500
    },

    button: {
        margin: Theme.BU / 2,
        width: '100%',
        marginBottom: 15
    },
    innerContainer: { marginTop: -4 }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            marginHorizontal: '20%',
            justifyContent: 'center',
            alignItems: 'center',
            marginVertical: Theme.primaryMargin
        },
        buttonContainer: {
            ...baseStyles.buttonContainer,
            flex: 1
        }
    };
}

export default StyleSheet.create(baseStyles);
